

























import {
  Component,
  Vue,
  Prop
} from "vue-property-decorator";

@Component
export default class DashboardCard extends Vue {
  @Prop() public cardRowData: {}[];
}
